import { call } from 'redux-saga/effects'
import { KanBoJsonApi } from 'api/Api'

export default function * requestChangeCurrentUserAvatar (action) {
  const { avatar } = action.payload

  yield call(KanBoJsonApi.action, 'SetMyAvatar', {
    contents: avatar
  })
}
